<template>
  <CustomBlipLineChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    :card-options="cardOptions"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import CustomBlipLineChart from '@/components/cards/models/CustomBlipLineChart';
import { mapActions, mapGetters } from 'vuex';
import colors from '@/utils/colors';
import EventBus from '@/utils/event-bus';
import cardsModel from '@/mixins/cards-model';

export default {
  name: 'BaseBlipLineChart',
  components: {
    CustomBlipLineChart,
  },
  mixins: [
    cardsModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    servicePath: {
      type: String,
      required: true,
    },
    interval: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      undefinedLabeL: this.$t('DataManagement.undefined'),
      rawSeries: [],
      filteredValues: [],
      categories: [],
    };
  },
  computed: {
    ...mapGetters('dashboard', [
      'activeDashboardFilters',
      'activeGlobalFilter',
    ]),
    cardOptions() {
      return {
        chart: {
          type: 'areaspline',
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            lineColor: colors.componentsColor.seriesLineColor,
            lineWidth: 1,
            fillOpacity: 1,
            fillColor: {
              linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
              stops: [
                [0, colors.componentsColor.seriesAreaColorStart],
                [1, colors.componentsColor.seriesAreaColorEnd],
              ],
            },
            marker: {
              fillColor: colors.componentsColor.seriesLineColor,
              radius: 2,
            },
            dataLabels: {
              enabled: true,
            },
          },
        },
        xAxis: {
          type: 'datetime',
        },
        tooltip: {
          pointFormatter() {
            return `<span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${this.y}</b><br/>`;
          },
        },
      };
    },
    series() {
      return [{
        data: this.rawSeries.map((serie, index) => ([this.categories[index], serie.count])),
        name: this.title,
      }];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getBlipService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }
      this.getBlipService({
        servicePath: this.servicePath,
        interval: this.interval,
        itemId: this.itemId,
      })
        .then((response) => {
          if (!response) {
            this.requestStatus = 'error';
            return;
          }

          this.rawSeries = response.resource.items;
          this.requestStatus = 'success';

          this.rawSeries.forEach(({ intervalEnd, count }) => {
            const timestamp = new Date(intervalEnd).getTime();
            this.series[0].data.push(timestamp, count);
            this.categories.push(timestamp);
          });

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((error) => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>
